import {OfferType} from "../../offer/types/OfferType";

interface IUnlockChoicePropertyNoun {
    nominative: string;
    genitive: string;
    locative: string;
}

export const getUnlockChoicePropertyNoun = (offerType: OfferType | null): IUnlockChoicePropertyNoun => {
    switch (offerType) {
        case OfferType.HOUSE:
        case OfferType.MODULAR_HOUSE:
            return {nominative: "dom", genitive: "domu", locative: "domu"};
        case OfferType.COMMERCIAL:
            return {nominative: "lokal użytkowy", genitive: "lokalu użytkowego", locative: "lokalu użytkowym"};
        default:
            return {nominative: "mieszkanie", genitive: "mieszkania", locative: "mieszkaniu"};
    }
};
import {OfferType} from "../../offer/types/OfferType";

interface IUnlockChoicePropertyNoun {
    nominative: string;
    genitive: string;
    locative: string;
}

export const getUnlockChoicePropertyNoun = (offerType: OfferType | null): IUnlockChoicePropertyNoun => {
    switch (offerType) {
        case OfferType.HOUSE:
        case OfferType.MODULAR_HOUSE:
            return {nominative: "dom", genitive: "domu", locative: "domu"};
        case OfferType.COMMERCIAL:
            return {nominative: "lokal użytkowy", genitive: "lokalu użytkowego", locative: "lokalu użytkowym"};
        default:
            return {nominative: "mieszkanie", genitive: "mieszkania", locative: "mieszkaniu"};
    }
};
